export default __webpack_public_path__ + "static/media/final-point.6cfd2b1a.svg";